import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import graphqlLib from './../../lib/graphql-lib';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { LOT_STATUS_OPTIONS, SPEC_STATUS_OPTIONS } from '../../constants/LotOptions';
import actions from '../../actions';
import _ from 'lodash';
import Promise from 'bluebird';
import {
	Table,
	DateInput,
	Button,
	Dropdown,
	Badge,
	Loader,
	Pagination,
	Icon,
	Spinner,
} from '../../components';
import Breadcrumb from './../../components/Breadcrumb';

// Import the CSS
import '../../../scss/containers/lots/_list.scss';

const DEFAULT_LIMIT = 20;

function formatAddress(lot) {
	let override = lot.override || {};
	let streetOne =
		'streetOne' in override ? override.streetOne : lot.specStreetOne || lot.streetOne;
	let streetTwo =
		'streetTwo' in override ? override.streetTwo : lot.specStreetTwo || lot.streetTwo;
	let city = 'city' in override ? override.city : lot.specCity || lot.city;
	let state = 'state' in override ? override.state : lot.specState || lot.state;
	let zip = 'zip' in override ? override.zip : lot.specZip || lot.zip;

	let address = 'No Address';

	// Make sure the required fields exist
	if (streetOne && city && state && zip) {
		address = `${
			streetTwo ? streetOne + ' ' + streetTwo : streetOne
		}, ${city} ${state}, ${zip}`;
	}

	return address;
}

/**
 * Formats the lot's move-in date.
 */
function formatMoveInDate(lot) {
	let override = lot.override || {};
	let moveInYear = 'moveInYear' in override ? override.moveInYear : lot.moveInYear;
	let moveInMonth = 'moveInMonth' in override ? override.moveInMonth : lot.moveInMonth;
	let moveInDay = 'moveInDay' in override ? override.moveInDay : lot.moveInDay;

	let moveInDate;

	// Make sure the required fields exist
	if (moveInYear && moveInMonth) {
		moveInDate = `${moveInYear}/${moveInMonth < 10 ? `0${moveInMonth}` : moveInMonth}`;

		if (moveInDay) {
			moveInDate += `/${moveInDay < 10 ? `0${moveInDay}` : moveInDay}`;
		}
	}

	return moveInDate;
}

function getLinkedCustomerId(subdivision) {
	return (
		subdivision &&
		(subdivision.customerId ||
			(subdivision.builder && subdivision.builder.customerId) ||
			(subdivision.corporation && subdivision.corporation.customerId) ||
			null)
	);
}

export class LotList extends Component {
	constructor(props) {
		super(props);

		const limit = this.props.location.query.limit || DEFAULT_LIMIT;
		let offset = 0;

		// If a page is set then calculate the offset
		if (this.props.location.query.page) {
			offset = (parseInt(this.props.location.query.page, 10) - 1) * limit;
		}

		this.state = {
			linkingCustomerPromise: null,
			searchingCustomersPromise: null,
			filterType: this.props.location.query.filterType,
			showCustomerDropdown: false,
			customerSearchError: null,
			customers: [],
			limit,
			offset,
		};

		this.handleAutoComplete = this.handleAutoComplete.bind(this);
		this.handleSelectCustomer = this.handleSelectCustomer.bind(this);
		this.handleClickLinkCustomer = this.handleClickLinkCustomer.bind(this);
		this.handleClickCloseDropdown = this.handleClickCloseDropdown.bind(this);
	}

	componentWillMount() {
		if (Number.isNaN(+this.props.params.subdivisionId)) {
			this.props.actions.setGlobalMsg('error', 'Invalid subdivision id');
			return;
		}

		// Load the plans
		this.props.actions.plans.fetchPlanList({ subdivisionId: this.props.params.subdivisionId });

		// Load the lot counts
		this.props.actions.lots.fetchLotCounts({
			subdivisionId: this.props.params.subdivisionId,
			withTypeCounts: true,
		});

		// Fetch the logs
		this.fetchLotList();
	}

	componentWillUnmount() {
		// Cancel any outstanding promises
		if (this.state.searchingCustomersPromise) {
			this.state.searchingCustomersPromise.cancel();
		}
		if (this.state.linkingCustomerPromise) {
			this.state.linkingCustomerPromise.cancel();
		}
	}

	componentWillReceiveProps(nextProps) {
		const newState = {};

		// Check if the page has changed.
		if (this.props.location.query.page !== nextProps.location.query.page) {
			if (nextProps.location.query.page) {
				newState.offset =
					(parseInt(nextProps.location.query.page, 10) - 1) * this.state.limit;
			} else {
				newState.offset = 0;
			}
		}

		// Check if the filter has changed.
		if (this.props.location.query.filterType !== nextProps.location.query.filterType) {
			newState.filterType = nextProps.location.query.filterType;
		}

		// Check if we should set the new state and reload the lot list
		if (Object.keys(newState).length) {
			this.setState(newState, this.fetchLotList);
		}
	}

	handleChangePage(page) {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				page,
			},
		});
	}

	handleChangeFilterType(filterType) {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				page: 1,
				filterType,
			},
		});
	}

	handleChangeLotStatus(lot, status) {
		this.props.actions.lots.editLot(lot.id, { status });
	}

	handleChangeSpecStatus(lot, specStatus) {
		this.props.actions.lots.editLot(lot.id, { specStatus });
	}

	handleChangePlans(lot, eligiblePlans) {
		// If the eligible plans list is empty then send NULL instead of an empty array
		if (!Array.isArray(eligiblePlans) || eligiblePlans.length === 0) {
			eligiblePlans = null;
		}

		this.props.actions.lots.editLot(lot.id, { eligiblePlans });
	}

	handleChangeMoveInDate(lot, moveInDate) {
		if (moveInDate == undefined) {
			return;
		}

		let dateParts = moveInDate.split('/', 3);
		let data = {
			moveInYear: parseInt(dateParts[0]),
			moveInMonth: parseInt(dateParts[1]),
			moveInDay: dateParts.length === 3 ? parseInt(dateParts[2]) : null,
		};

		this.props.actions.lots.editLot(lot.id, data);
	}

	handleClickLinkCustomer(e) {
		e.preventDefault();

		this.setState({ showCustomerDropdown: true });
	}

	handleClickCloseDropdown(e) {
		e.preventDefault();

		this.setState({ showCustomerDropdown: false, customers: [] });
	}

	async handleSelectCustomer(selection) {
		if (this.state.linkingCustomerPromise) {
			this.state.linkingCustomerPromise.cancel();
		}

		const customer = selection.value;
		const message = customer
			? `${customer.name} has been successfully linked to this community.`
			: 'Subdivision has been successfully unlinked.';

		this.setState({ showCustomerDropdown: false });

		try {
			const linkingCustomerPromise = Promise.resolve(
				this.props.linkSubdivisionCustomer(customer ? customer.id : null),
			);

			this.setState({ linkingCustomerPromise });

			await linkingCustomerPromise;

			this.props.actions.setGlobalMsg('success', message);

			this.setState({
				linkingCustomerPromise: null,
				customers: [],
				customer,
			});
		} catch (err) {
			this.props.actions.setGlobalMsg('error', 'Error occurred while linking customer.');

			this.setState({
				linkingCustomerPromise: null,
				customers: [],
			});
		}
	}

	async handleAutoComplete(value) {
		if (this.state.searchingCustomersPromise) {
			this.state.searchingCustomersPromise.cancel();
		}

		// Clear dropdown list and return early if the input value is empty
		// Render the default option only if there is a linked customer
		if (!value) {
			return this.setState({ customers: [] });
		}

		try {
			const searchingCustomersPromise = Promise.resolve(
				this.props.client.query({
					query: searchCustomersQuery,
					variables: {
						filter: {
							query: `%${value}%`,
						},
					},
				}),
			);

			this.setState({ searchingCustomersPromise });

			const {
				data: { customers },
			} = await searchingCustomersPromise;

			this.setState({
				customerSearchError: null,
				searchingCustomersPromise: null,
				customers: customers ? customers.results : [],
			});
		} catch (err) {
			this.setState({
				customerSearchError: err,
				searchingCustomersPromise: null,
			});
		}
	}

	fetchLotList() {
		const params = {
			limit: this.state.limit,
			offset: this.state.offset,
			subdivisionId: this.props.params.subdivisionId,
		};

		if (this.state.filterType) {
			params.type = this.state.filterType;
		}

		// Load the lots
		this.props.actions.lots.fetchLotList(params);
	}

	render() {
		const { subdivisionQuery, customerQuery } = this.props;

		const subdivision = _.get(subdivisionQuery, 'subdivision');
		const builder = _.get(subdivisionQuery, 'subdivision.builder');
		const corporation = _.get(subdivisionQuery, 'subdivision.corporation');
		const customer = _.get(customerQuery, 'customer');
		const isLoadingSubdivision = _.get(subdivisionQuery, 'loading');
		const isLoadingCustomer = _.get(customerQuery, 'loading');
		let lots = this.props.lots;
		let plans = this.props.plans;
		let pagination = this.props.pagination;

		const isLoadingPage =
			isLoadingSubdivision || this.props.isFetchingLotCounts || this.props.isFetchingPlans;

		if (!isLoadingPage && (!corporation || !builder || !subdivision)) {
			return null;
		}

		// Show the page loader
		if (isLoadingPage) {
			return <Loader overlay />;
		}

		let breadcrumbs = [
			{ url: '/corporations', label: 'Corporations' },
			{ url: '/' + corporation.rawId, label: corporation.name },
			{ url: '/builders/' + builder.rawId, label: builder.name },
			{ url: '/subdivisions/' + subdivision.rawId, label: subdivision.name },
		];

		let allBtnStyle = !this.state.filterType ? '' : 'gray-border';
		let specBtnStyle = this.state.filterType === 'spec' ? 'purple' : 'gray-border';
		let plansBtnStyle = this.state.filterType === 'plan' ? 'info' : 'gray-border';
		let emptyBtnStyle = this.state.filterType === 'empty' ? 'warning' : 'gray-border';

		// Initialize the customer options
		const selectedCustomer = customer && {
			value: customer,
			label: customer.name,
		};
		const customerOptions = this.state.customers.map(c => ({
			label: c.name,
			value: c,
		}));

		// Show the default unlink customer option if there is an existing
		// subdivision-level customer link and no dropdown options
		const shouldShowUnlinkOption =
			!!customer &&
			!this.state.customers.length &&
			!builder.customerId &&
			!corporation.customerId;

		if (shouldShowUnlinkOption) {
			// Add to the beginning of the dropdown option list
			customerOptions.unshift({
				style: 'default',
				value: '',
				label: (
					<div>
						<Icon type="unlink" />
						<span>Unlink current customer</span>
					</div>
				),
			});
		}

		// Get the list of plan options
		let planOptions = [];

		if (plans) {
			planOptions = plans.map(plan => ({
				label: plan.name,
				value: plan.number,
			}));
		}

		return (
			<div className="lot-list-container">
				<Breadcrumb paths={breadcrumbs} />
				<div className="row row-thirds page-header">
					<div className="cell">
						<h1>{subdivision.name}</h1>
					</div>
					<div className="cell justify-center">
						<Loader visible={this.props.isFetchingLots} />
					</div>
					<div className="cell justify-right filter-buttons">
						<Button
							onClick={() => this.handleChangeFilterType(null)}
							size="small"
							style={allBtnStyle}>
							All
						</Button>
						<Button
							onClick={() => this.handleChangeFilterType('spec')}
							size="small"
							style={specBtnStyle}>
							Spec
							<Badge shape="square" style="purple">
								{this.props.lotCounts.spec}
							</Badge>
						</Button>
						<Button
							onClick={() => this.handleChangeFilterType('plan')}
							size="small"
							style={plansBtnStyle}>
							Lot with Plan
							<Badge shape="square" style="info">
								{this.props.lotCounts.plan}
							</Badge>
						</Button>
						<Button
							onClick={() => this.handleChangeFilterType('empty')}
							size="small"
							style={emptyBtnStyle}>
							Empty Lot
							<Badge shape="square" style="warning">
								{this.props.lotCounts.empty}
							</Badge>
						</Button>
					</div>
				</div>
				<div className="row page-header">
					<div className="subdivision-info cell">
						<If condition={this.props.user.can('view-customer-list')}>
							<div className="subdivision-detail">
								<div className="detail-name">Customer</div>
								<Choose>
									<When
										condition={
											isLoadingCustomer || this.state.linkingCustomerPromise
										}>
										<div className="loading">
											<Spinner style="inline" />
											{this.state.linkingCustomerPromise
												? 'Linking customer...'
												: 'Loading customer...'}
										</div>
									</When>
									<When condition={this.state.showCustomerDropdown}>
										<Dropdown
											wrap
											name="customer-auto-complete"
											error={!!this.state.customerSearchError}
											isFetchingOptions={
												!!this.state.searchingCustomersPromise
											}
											autoComplete={this.handleAutoComplete}
											onChange={this.handleSelectCustomer}
											placeholder="Search by customer name..."
											selected={selectedCustomer}
											options={customerOptions}
											emptyLabel={
												<span className="placeholder">
													Link a customer to this community
												</span>
											}
										/>
										<Button
											size="smaller"
											onClick={this.handleClickCloseDropdown}>
											Cancel
										</Button>
									</When>
									<Otherwise>
										{customer ? (
											<div className="detail customer-name">
												{customer.name}
											</div>
										) : (
											<div className="detail no-customer">
												No customer linked.
											</div>
										)}
										<Button
											className="customer-action-button"
											size="smaller"
											onClick={this.handleClickLinkCustomer}>
											{customer ? 'Edit' : 'Add'}
										</Button>
									</Otherwise>
								</Choose>
							</div>
						</If>
					</div>
				</div>
				<Table className="lots-list">
					<thead>
						<tr>
							<th>Lot ID</th>
							<th>Lot #</th>
							<th>Address</th>
							<th>Lot Status</th>
							<th>Spec Status</th>
							<th>Plans</th>
							<th>Move-In Date</th>
						</tr>
					</thead>
					<tbody>
						{lots.map(lot => {
							let classes = [];
							let override = lot.override || {};
							let status = 'status' in override ? override.status : lot.status;
							let specNumber =
								'specNumber' in override ? override.specNumber : lot.specNumber;
							let specStatus =
								'specStatus' in override ? override.specStatus : lot.specStatus;
							let eligiblePlans =
								'eligiblePlans' in override
									? override.eligiblePlans
									: lot.eligiblePlans;
							let address = formatAddress(lot);
							let moveInDate = formatMoveInDate(lot);
							let selectedPlan = lot.planId
								? _.find(plans, { id: lot.planId })
								: null;

							if (specNumber) {
								classes.push('row-purple');
							} else if (Array.isArray(eligiblePlans) && eligiblePlans.length > 0) {
								classes.push('row-blue');
							} else {
								classes.push('row-orange');
							}

							return (
								<tr key={lot.id} className={classes.join(' ')}>
									<td className="sm-col">{lot.id}</td>
									<td className="sm-col">{lot.number}</td>
									<td>{address}</td>
									<Choose>
										<When condition={this.props.user.can('edit-data')}>
											<td className="no-pad gray-bg med-col">
												<Dropdown
													name="lotStatus"
													emptyLabel="Choose a Status"
													onChange={status =>
														this.handleChangeLotStatus(lot, status)
													}
													options={LOT_STATUS_OPTIONS}
													selected={status}
												/>
											</td>
											<td
												className={
													specNumber
														? 'no-pad gray-bg med-col'
														: 'med-col'
												}>
												<Choose>
													<When condition={specNumber}>
														<Dropdown
															name="specStatus"
															emptyLabel="Choose a Status"
															onChange={status =>
																this.handleChangeSpecStatus(
																	lot,
																	status,
																)
															}
															options={SPEC_STATUS_OPTIONS}
															selected={specStatus}
														/>
													</When>
													<When condition={!specNumber}>Not a spec</When>
												</Choose>
											</td>
											<td
												className={
													!specNumber
														? 'no-pad gray-bg med-col'
														: 'med-col'
												}>
												<Choose>
													<When condition={!specNumber}>
														<Dropdown
															name="plans[]"
															emptyLabel="Choose a Plan"
															multipleLabel="{num} Plans"
															multiple
															onChange={plans =>
																this.handleChangePlans(lot, plans)
															}
															options={planOptions}
															selected={eligiblePlans}
														/>
													</When>
													<When condition={specNumber && selectedPlan}>
														{selectedPlan.name}
													</When>
													<When condition={specNumber && !selectedPlan}>
														<Icon type="warning-circle" /> Plan #
														{lot.planId} does not exist
													</When>
												</Choose>
											</td>
											<td className="no-pad gray-bg med-col">
												<DateInput
													name="moveInDate"
													defaultValue={moveInDate}
													placeholder="YYYY/MM or YYYY/MM/DD"
													onSetDate={date =>
														this.handleChangeMoveInDate(lot, date)
													}
												/>
											</td>
										</When>
										<When condition={!this.props.user.can('edit-data')}>
											<td>
												<Choose>
													<When condition={status}>
														{
															_.find(LOT_STATUS_OPTIONS, {
																value: status,
															}).label
														}
													</When>
													<When condition={!status}>No Lot Status</When>
												</Choose>
											</td>
											<td>
												<Choose>
													<When condition={!specNumber}>Not a spec</When>
													<When condition={specNumber}>
														<Choose>
															<When condition={specStatus}>
																{
																	_.find(SPEC_STATUS_OPTIONS, {
																		value: specStatus,
																	}).label
																}
															</When>
															<When condition={!specStatus}>
																No Spec Status
															</When>
														</Choose>
													</When>
												</Choose>
											</td>
											<td>
												<Choose>
													<When condition={!specNumber}>
														<Choose>
															<When condition={!eligiblePlans}>
																No Plans
															</When>
															<When
																condition={
																	eligiblePlans &&
																	eligiblePlans.length === 1
																}>
																{
																	_.find(plans, {
																		number: eligiblePlans[0],
																	}).name
																}
															</When>
															<When
																condition={
																	eligiblePlans &&
																	eligiblePlans.length > 1
																}>
																{`${eligiblePlans.length} Plans`}
															</When>
														</Choose>
													</When>
													<When condition={specNumber && selectedPlan}>
														{selectedPlan.name}
													</When>
													<When condition={specNumber && !selectedPlan}>
														<Icon type="warning-circle" /> Plan #
														{lot.planId} does not exist
													</When>
												</Choose>
											</td>
											<td>{moveInDate}</td>
										</When>
									</Choose>
								</tr>
							);
						})}
					</tbody>
				</Table>
				<If condition={pagination}>
					<Pagination
						totalPages={pagination.pages.total}
						currentPage={pagination.pages.current}
						onPageChange={page => this.handleChangePage(page)}
					/>
				</If>
			</div>
		);
	}
}

LotList.propTypes = {
	location: PropTypes.object,
	params: PropTypes.object,
	actions: PropTypes.object,
	client: PropTypes.object,
	user: PropTypes.object,
	lots: PropTypes.array,
	plans: PropTypes.array,
	pagination: PropTypes.object,
	subdivisionQuery: PropTypes.object,
	customerQuery: PropTypes.object,
	linkSubdivisionCustomer: PropTypes.func,
	isFetchingLotCounts: PropTypes.bool,
	isFetchingLots: PropTypes.bool,
	isFetchingPlans: PropTypes.bool,
	lotCounts: PropTypes.object,
};

export const subdivisionQuery = gql`
	query fetchSubdivision($subdivisionId: EncodedID!) {
		subdivision(id: $subdivisionId) {
			id
			rawId: id(raw: true)
			name
			number
			customerId
			builder {
				id
				rawId: id(raw: true)
				name
				customerId
			}
			corporation {
				id
				rawId: id(raw: true)
				name
				customerId
			}
		}
	}
`;

export const fetchCustomerQuery = gql`
	query fetchCustomer($id: EncodedID!) {
		customer(id: $id) {
			id
			rawId: id(raw: true)
			name
			billingId
		}
	}
`;

export const searchCustomersQuery = gql`
	query searchCustomers($filter: CustomerFilters) {
		customers(filter: $filter, limit: 10) {
			results {
				id
				rawId: id(raw: true)
				name
				billingId
			}
		}
	}
`;

export const linkSubdivisionCustomerMutation = gql`
	mutation linkSubdivisionCustomer($subdivisionId: EncodedID!, $customerId: EncodedID) {
		updateSubdivision(input: { id: $subdivisionId, customerId: $customerId }) {
			id
			customerId
			builder {
				id
				customerId
			}
			corporation {
				id
				customerId
			}
		}
	}
`;

export default compose(
	connect(
		state => ({
			user: state.auth.user,
			plans: state.plans.list,
			plansError: state.plans.error,
			isFetchingPlans: state.plans.isFetchingList,
			lots: state.lots.list,
			pagination: state.lots.pagination,
			lotsError: state.lots.error,
			isFetchingLots: state.lots.isFetchingList,
			lotCounts: state.lots.counts,
			isFetchingLotCounts: state.lots.isFetchingCounts,
		}),
		dispatch => ({
			actions: {
				lots: bindActionCreators(actions.lots, dispatch),
				plans: bindActionCreators(actions.plans, dispatch),
				setGlobalMsg: bindActionCreators(actions.globalMsg.setGlobalMsg, dispatch),
			},
		}),
	),
	graphql(subdivisionQuery, {
		name: 'subdivisionQuery',
		skip: props => Number.isNaN(+props.params.subdivisionId),
		options: props => ({
			variables: {
				subdivisionId: graphqlLib.encodeId('subdivision', props.params.subdivisionId),
			},
		}),
	}),
	graphql(fetchCustomerQuery, {
		name: 'customerQuery',
		skip: ({ subdivisionQuery }) => {
			// Skip if still fetching the subdivision or could not fetch subdivision
			if (subdivisionQuery.loading || !subdivisionQuery.subdivision) {
				return true;
			}

			// Skip if linkedCustomerId is null
			const linkedCustomerId = getLinkedCustomerId(subdivisionQuery.subdivision);
			if (!linkedCustomerId) {
				return true;
			}
		},
		options: ({ subdivisionQuery }) => {
			const linkedCustomerId = getLinkedCustomerId(subdivisionQuery.subdivision);

			return {
				variables: {
					id: linkedCustomerId,
				},
			};
		},
	}),
	graphql(linkSubdivisionCustomerMutation, {
		props: ({ ownProps, mutate }) => ({
			linkSubdivisionCustomer: customerId =>
				mutate({
					variables: {
						customerId,
						subdivisionId: graphqlLib.encodeId(
							'subdivision',
							ownProps.params.subdivisionId,
						),
					},
				}),
		}),
	}),
)(LotList);



// WEBPACK FOOTER //
// ./src/assets/js/containers/lots/List.js